// Cryptocurrency wallet addresses for donations (from Magic Forest)
export const CRYPTO_WALLETS = [
  { currency: 'Bitcoin (BTC)', address: 'bc1qmyr3u0dpz6y49xzgss5n2upqqu8ejjwxfgrx2k', symbol: 'BTC' },
  { currency: 'Ethereum (ETH)', address: '0x7196d1f1a2a56269a5a1ed40668793f96ba72d50', symbol: 'ETH' },
  { currency: 'USD Coin (USDC) over Ethereum', address: '0x7196d1f1a2a56269a5a1ed40668793f96ba72d50', symbol: 'USDC' },
  { currency: 'Tezos (XTZ)', address: 'tz1YntcdpNYSBLsv5qY3Aib9v64vEnCX3fog', symbol: 'XTZ' },
  { currency: 'Solana (SOL)', address: 'GrzPF9ECv249cUcRtMZxvqRqxJHWmFLX4qwEvbm8xuuF', symbol: 'SOL' },
];

export const generateQRCode = (data, size = 80) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(data)}`;

export const copyCryptoAddress = async (address, currency) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(address);
      return true;
    }
    const ta = document.createElement('textarea');
    ta.value = address;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
};
